module.exports = __webpack_public_path__ + "img/paygate-plus.0e3203d8.jpg";